export function getMediaTypeFilterValues(selectedMediaTypes) {
  const selections = Array.isArray(selectedMediaTypes)
    ? selectedMediaTypes
    : selectedMediaTypes == null
      ? []
      : [selectedMediaTypes];

  return selections
    .map((mediaType) => (typeof mediaType === 'object' ? mediaType.v : mediaType))
    .filter((mediaType) => mediaType != null);
}
